import 'theme/theme.css';
import { FC } from 'react';

import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';

import theme from 'theme/Theme';

import Router from './Router';

export const QuoteComponent: FC = () => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <Router />
    </ThemeProvider>
  </StyledEngineProvider>
);

export default QuoteComponent;
